import { render, staticRenderFns } from "./goods-sales-rank.vue?vue&type=template&id=082512af&scoped=true&"
import script from "./goods-sales-rank.vue?vue&type=script&lang=js&"
export * from "./goods-sales-rank.vue?vue&type=script&lang=js&"
import style0 from "./goods-sales-rank.vue?vue&type=style&index=0&id=082512af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082512af",
  null
  
)

export default component.exports